import React from "react";
import { connect } from "react-redux";
import { Switch, Redirect } from "react-router";
import { HashRouter,Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ConnectedRouter } from "connected-react-router";
import { getHistory } from "../src/reducers/store";
import { AdminRoute, UserRoute, AuthRoute } from "./RouteComponents";

import ErrorPage from "./pages/error/ErrorPage.js";
import LayoutComponent from "./components/Layout/Layout";
import Login from "./pages/auth/login/Login";

import "./styles/app.scss";
import RecoverPassword from "./pages/auth/pass-reset/sendEmail";
import ResetPassword from "./pages/auth/pass-reset/ResetPassword";

const Router = (props) => {
  return (
    <div>
      <ToastContainer/>
      <ConnectedRouter history={getHistory()}>
        <HashRouter>
          <Switch>
            <Route path="/" exact render={() => <Redirect to="/template/dashboard" />} />
            <Route path="/template" exact render={() => <Redirect to="/template/dashboard"/>} />
            <UserRoute
              path="/template"
              dispatch={props.dispatch}
              component={LayoutComponent}
            />
            <AdminRoute
              path="/admin"
              currentUser={props.currentUser}
              dispatch={props.dispatch}
              component={LayoutComponent}
            />
            <AuthRoute path="/login" exact component={Login} />

            <Route path="/recuperar-cuenta" exact component={RecoverPassword} />
            <Route path="/cambiar-contraseña" exact component={ResetPassword} />

            <Route path="/error" exact component={ErrorPage} />
            <Redirect from="*" to="/template/dashboard" />
            <Route path='*' exact render={() => <Redirect to="/error" />} />
          </Switch>
        </HashRouter>
      </ConnectedRouter>
    </div>
  );
}

const mapStateToProps = state => ({
  currentUser: state.auth.currentUser,
  loadingInit: state.auth.loadingInit
});

export default connect(mapStateToProps)(Router);
